import type { SubscriptionTier } from '@/lib/subscription';
import { isPremiumUser, type SubscriptionProfileFields } from '@/lib/subscription';

export type PremiumFeature =
  | 'goals'
  | 'snowball'
  | 'budgets'
  | 'yearly_dashboard'
  | 'bank_statement_import'
  | 'email_notifications'
  | 'foco_score_detail'
  | 'ai_chat';

const FREE_STATEMENT_IMPORT_LIMIT = 1;

export interface PremiumGateContext {
  isAdmin: boolean;
  profile: SubscriptionProfileFields | null | undefined;
}

export function canAccessPremiumFeature(
  _feature: PremiumFeature,
  ctx: PremiumGateContext,
): boolean {
  return isPremiumUser(ctx.profile, ctx.isAdmin);
}

export function canImportBankStatement(ctx: PremiumGateContext): boolean {
  if (isPremiumUser(ctx.profile, ctx.isAdmin)) return true;
  const count = ctx.profile?.successful_statement_imports ?? 0;
  return count < FREE_STATEMENT_IMPORT_LIMIT;
}

export function getTier(ctx: PremiumGateContext): SubscriptionTier {
  if (ctx.isAdmin) return 'premium';
  return ctx.profile?.subscription_tier ?? 'free';
}
